import { render, staticRenderFns } from "./ExploreWeb3.vue?vue&type=template&id=263b291c"
import script from "./ExploreWeb3.vue?vue&type=script&lang=js"
export * from "./ExploreWeb3.vue?vue&type=script&lang=js"
import style0 from "./ExploreWeb3.vue?vue&type=style&index=0&id=263b291c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports